import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ep_admin_token_v1";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Notify listeners of data changes
export const emitDataUpdated = () =>
  window.dispatchEvent(new Event("ep-data-updated"));

// ---------- Matches ----------
export const fetchMatches = async () => {
  const { data } = await client.get("/matches");
  return data;
};

export const createMatch = async (match) => {
  const { data } = await client.post("/matches", match);
  emitDataUpdated();
  return data;
};

export const updateMatch = async (id, match) => {
  const { data } = await client.put(`/matches/${id}`, match);
  emitDataUpdated();
  return data;
};

export const deleteMatchApi = async (id) => {
  const { data } = await client.delete(`/matches/${id}`);
  emitDataUpdated();
  return data;
};

// ---------- Stats ----------
export const fetchStats = async () => {
  const { data } = await client.get("/stats");
  return data; // { mode, winningTipsLastYear, activeMembers, averageWinRate }
};

export const fetchComputedStats = async () => {
  const { data } = await client.get("/stats/computed");
  return data;
};

export const updateStats = async (payload) => {
  const { data } = await client.put("/stats", payload);
  emitDataUpdated();
  return data;
};

// ---------- Auth ----------
export const adminLogin = async (username, password) => {
  const { data } = await client.post("/admin/login", { username, password });
  setToken(data.token);
  return data;
};

export const adminMe = async () => {
  const { data } = await client.get("/admin/me");
  return data;
};

export const logout = () => {
  setToken(null);
};

// ---------- Contact ----------
export const submitContact = async (body) => {
  const { data } = await client.post("/contact", body);
  return data;
};

// ---------- Plans overrides ----------
export const fetchPlansConfig = async () => {
  const { data } = await client.get("/plans");
  return data || {};
};

export const updatePlansConfig = async (payload) => {
  const { data } = await client.put("/plans", payload);
  emitDataUpdated();
  return data;
};

export default client;
